import React from 'react';
import styled from '@emotion/styled';
import { InstitutionLogoProps } from './types';
import { MIXIN_SCREEN_READER_TEXT } from '../../Style/mixins';

const InstitutionLogoContainer = styled('a')({
  display: 'block',
  width: '100%',
  minWidth: 50,
  padding: 10,
});

const ImageWrap = styled('div')({
  display: 'block',
  position: 'relative',
  width: '100%',
  paddingTop: 'calc(100% * 1 / 2)',
});

interface ImageProps {
  logoUrl: string;
}

const Image = styled('span')<ImageProps>((props) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  backgroundSize: 'contain',
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  display: 'block',
  backgroundImage: `url("${props.logoUrl}")`,
}));

const TextReaderOnlyText = styled('span')(MIXIN_SCREEN_READER_TEXT);

export const InstitutionLogo = React.memo(
  ({ logoUrl, name, className, url }: InstitutionLogoProps) => {
    return (
      <InstitutionLogoContainer className={className} href={url} title={name}>
        <ImageWrap>
          <Image logoUrl={logoUrl || ''}>
            <TextReaderOnlyText>{name}</TextReaderOnlyText>
          </Image>
        </ImageWrap>
      </InstitutionLogoContainer>
    );
  }
);
